<template>
  <!-- 

  [ 레이아웃 옵션 / default : vertical ]
  .horizontal : 가로정렬 레이아웃
  .vertical : 세로정렬 레이아웃


  [ 간격 옵션 / defauly : spacing--sm ]
  .spacing--sm
  .spacing--md
  .spacing--lg


  [ 폰트크기 옵션 / default : font--md ]
  .font--xs
  .font--sm
  .font--md
  .font--lg
  .font--xl


  [ 폰트두께 옵션 / default : font--400 ]
  .font--100
  .font--200
  .font--300
  .font--400
  .font--500
  .font--600
  .font--700
  .font--800
  .font--900  


  [ 보더옵션 / default : 없음 ]
  .border--solid
  .border--dashed


  [ 색상 테마 옵션 / default : theme--black ]
  .theme--black : 메뉴 폰트, 아이콘 검정
  .theme--white : 메뉴 폰트, 아이콘 흰색


  [ 호버 옵션 / default : 없음 ]
  .hover--bg
  .hover--opacity

  [ 아이콘 옵션 / default : hidden ]
  .icon--view
  -->

  <nav class="menu-user__container OPTION spacing--md">
    <ul class="menu-user">
      <!-- is-selected 추가시 서브메뉴 펼처짐 -->
      <li
        class="menu-user__item"
        v-if="user.level >= $utils.getLevel('master1') && !isAdminMode"
      >
        <a
          @click="$router.push({name: 'adminMain'})"
          class="menu-user-link"
        >
          <i class="material-icons">launch</i>
          <span class="menu-user__label">어드민</span>
        </a>
      </li>
      <li
        class="menu-user__item"
        v-if="user.level >= $utils.getLevel('master1') && isAdminMode"
      >
        <a
          @click="$router.push({name: 'home'})"
          class="menu-user-link"
        >
          <i class="material-icons">launch</i>
          <span class="menu-user__label">홈</span>
        </a>
      </li>

      <li
        class="menu-user__item"
        v-if="user.role && !isAdminMode"
      >
        <a
          @click="$router.push({name: 'mypage'})"
          class="menu-user-link"
        >
          <i class="material-icons">person_outline</i>
          <span class="menu-user__label">마이페이지</span>
        </a>
      </li>

      <li
        class="menu-user__item"
        v-if="!user.role"
      >
        <a
          @click="$router.push({name: 'signUp'})"
          class="menu-user-link"
        >
          <i class="material-icons">lock_open</i>
          <span class="menu-user__label">회원가입</span>
        </a>
      </li>
      <li
        class="menu-user__item"
        v-if="!user.role"
      >
        <a
          @click="$router.push({name: 'login'})"
          class="menu-user-link"
        >
          <i class="material-icons">lock_open</i>
          <span class="menu-user__label">로그인</span>
        </a>
      </li>
      <li
        class="menu-user__item"
        v-if="user.role"
      >
        <a
          @click.stop="logout"
          class="menu-user-link"
        >
          <i class="material-icons">lock_open</i>
          <span class="menu-user__label">로그아웃</span>
        </a>
      </li>

      <!-- <li class="menu-user__item">
        <a
          href="#"
          class="menu-user-link"
        >
          <i class="material-icons">favorite_border</i>
          <span class="menu-user__label">Wishlist</span>
        </a>
      </li>
      <li class="menu-user__item">
        <a
          href="#"
          class="menu-user-link"
        >
          <i class="material-icons">work_outline</i>
          <span class="menu-user__label">Cart</span>
        </a>
      </li> -->
    </ul>
  </nav>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      clicked: false
    }
  },
  computed: {
    ...mapState(['user']),
    isAdminMode () {
      return this.$route.name.startsWith('admin')
    }
  },
  methods: {
    async logout () {
      try {
        await this.$http.post('/api/auth/logout')
      } finally {
        this.$store.commit('SET_USER_INFO', {})
        this.$router.push({ name: 'home' })
      }
    },
    onBlur () {
      this.clicked = false
    }
  }
}
</script>
